<div class="tag-manager" [class.error]="isError">
  <mat-chip-list>
    <mat-chip *ngFor="let tag of tags" [removable]="editable" (removed)="removeTag(tag)">
      {{ tag }}
      <mat-icon matChipRemove *ngIf="editable">cancel</mat-icon>
    </mat-chip>
    <input *ngIf="editable" [placeholder]="placeholder" [formControl]="tagCtrl" (keydown)="addTag($event)" matInput />
  </mat-chip-list>

</div>
<mat-error *ngIf="isError">{{errorMessage}}</mat-error>